import axios from 'axios'

export const createAxiosClient = ({ baseURL = '', timeout = 10000 } = {}) =>
  axios.create({
    baseURL,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    timeout,
  })
